import { LeaderboardActions, LeaderboardTypes, SortDirection } from './leaderboardTypes';

const leaderboardReducer = (
    state: LeaderboardTypes,
    action: LeaderboardActions
): LeaderboardTypes => {
    switch (action.type) {
        case 'SET_SORT':
            return {
                ...state,
                activeSort:
                    state.activeSort.sortKey === action.payload
                        ? {
                              ...state.activeSort,
                              direction:
                                  state.activeSort.direction === SortDirection.ASC
                                      ? SortDirection.DESC
                                      : SortDirection.ASC,
                          }
                        : {
                              sortKey: action.payload,
                              direction: SortDirection.DESC,
                          },
            };

        default:
            return state;
    }
};

export default leaderboardReducer;
